import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class UpdateInvestorGoalError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('UpdateInvestorGoalError', ...args);
    }
}
export default UpdateInvestorGoalError;
